module.exports = __webpack_public_path__ + "img/20190615104143538.ad4d9683.png";